module.exports = __webpack_public_path__ + "img/left-btn-arrow.30e01b18.svg";